<template>
  <div>
    <el-container>
      <el-main>
        <div :style="recordListStyle">
          <el-row class="row-margin-top">
            <el-table
              :data="recordList"
              ref="selRecordsTable"
              @selection-change="selRecords"
              :row-class-name="tableRowClassName"
            >
              <el-table-column width="25px;"></el-table-column>
              <el-table-column
                prop="recorddate"
                :label="$t('langcfg.txtCreationDate')"
                width="220px;"
              >
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" style="height: 40px"></div>
                  <span style="font-size: 23px">{{
                    recordList[scope.$index].recorddate | dateFormater("yyyy/MM/DD", true)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('langcfg.txtEye')" width="100px;">
                <template slot-scope="scope">
                  <div style="height: 40px" v-if="scope.$index === 0"></div>
                  <div style="margin-bottom: 23px; font-size: 23px; line-height: 50px">OD</div>
                  <div style="font-size: 23px; line-height: 40px">OS</div>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in menus.filter((v) => v.key !== 'questionnaire')"
                :key="item.key"
                :label="$t(`langcfg.${item.label}`)"
                width="auto"
                style="white-space: nowrap"
              >
                <template slot-scope="scope">
                  <div class="item" :style="item.key === 'tearheight' ? 'padding-left: 69px' : ''">
                    <input
                      :id="item.key"
                      v-if="scope.$index === 0"
                      @change="printSettingsChange(item.key)"
                      style="width: 25px; height: 25px"
                      type="checkbox"
                      :checked="printSettings.dryeye[item.key]"
                    />
                  </div>
                  <div>
                    <div @row-click="tableClick" style="display: flex">
                      <div style="line-height: 78px; position: absolute; left: -50px">
                        <input
                          :id="`dataOD${scope.$index}`"
                          v-if="index === 0"
                          type="checkbox"
                          @change="selDataOD(scope.$index, scope.row.content.dataOD, 'OD')"
                          style="
                            vertical-align: -6px;
                            height: 25px;
                            width: 25px;
                            margin-right: 16px;
                            font-size: 40px;
                          "
                        />
                      </div>
                      <div
                        :style="`line-height: 70px; height: 70px; width: 100%; ${item.key === 'tearheight' ? 'padding-left: 40px' : ''}`"
                      >
                        <el-button
                          style="width: 100%; text-align: left"
                          @click="
                            selDataOD(scope.$index, scope.row.content.dataOD, 'OD', '0', true)
                          "
                          round
                        >
                          <span
                            :style="
                              getCellColor(
                                scope.row.content.dataOD[item.key]
                                  ? scope.row.content.dataOD[item.key].diagnosed
                                  : false,
                                scope.$index
                              )
                            "
                          >
                            <i
                              class="fullcircle"
                              v-if="
                                scope.row.content.dataOD[item.key] &&
                                (scope.row.content.dataOD[item.key].diagnosed ||
                                  (item.key === 'fbut'
                                    ? scope.row.content.dataOD[item.key][0].diagnosed
                                    : false))
                              "
                            ></i>
                            <i class="circle" v-else></i>
                          </span>
                        </el-button>
                      </div>
                    </div>
                    <div style="display: flex">
                      <div style="line-height: 78px; position: absolute; left: -50px">
                        <input
                          :id="`dataOS${scope.$index}`"
                          v-if="index === 0"
                          type="checkbox"
                          @change="selDataOS(scope.$index, scope.row.content.dataOS, 'OS')"
                          style="
                            vertical-align: -4px;
                            height: 25px;
                            width: 25px;
                            margin-right: 16px;
                            vertical-algin: 6;
                          "
                        />
                      </div>
                      <div
                        :style="`line-height: 70px; height: 70px; width: 100%; ${item.key === 'tearheight' ? 'padding-left: 40px' : ''}`"
                      >
                        <el-button
                          style="width: 100%; text-align: left"
                          @click="
                            selDataOS(scope.$index, scope.row.content.dataOS, 'OS', '0', true)
                          "
                          round
                        >
                          <span
                            :style="
                              getCellColor(
                                scope.row.content.dataOS[item.key]
                                  ? scope.row.content.dataOS[item.key].diagnosed
                                  : false,
                                scope.$index
                              )
                            "
                          >
                            <!-- {{
                            scope.row.content.dataOS[item] &&
                            scope.row.content.dataOS[item].diagnosed
                              ? $t('langcfg.txtTested')
                              : $t('langcfg.txtNottested')
                          }} -->
                            <i
                              class="fullcircle"
                              v-if="
                                scope.row.content.dataOS[item.key] &&
                                (scope.row.content.dataOS[item.key].diagnosed ||
                                  (item.key === 'fbut'
                                    ? scope.row.content.dataOS[item.key][0].diagnosed
                                    : false))
                              "
                            ></i>
                            <i class="circle" v-else></i>
                          </span>
                        </el-button>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </el-main>
      <el-footer style="border-top: 1px solid gray">
        <div class="footer" :style="`position: absolute;height:${255 - 140}px;`">
          &nbsp; &nbsp;<span style="font-size: 45px">○</span>&nbsp;-&nbsp;{{
            $t("langcfg.txtNottested")
          }}
          &nbsp; &nbsp;<span style="font-size: 45px"> ●</span> &nbsp;-&nbsp;{{
            $t("langcfg.txtTested")
          }}
        </div>
        <div
          class="wrapper-full footer"
          :style="`height:${255 - 140}px;margin-left:${isDE || isIT ? 100 : 0}px`"
        >
          <el-radio-group v-model="currentVersion" @change="selVersion">
            <el-radio label="1" style="font-size: 20px">{{
              $t("langcfg.txtClassicVersion")
            }}</el-radio>
            <el-radio
              v-if="isZHCN"
              label="2"
              style="font-size: 20px; padding-left: 35px"
              class="elRadio"
              >{{ $t("langcfg.txtSimpleVersion") }}</el-radio
            >
            <el-radio label="3" style="font-size: 20px; padding-left: 35px" class="elRadio">{{
              $t("langcfg.txtMeibomian")
            }}</el-radio>
          </el-radio-group>
          <el-button
            type="primary"
            v-if="recordList"
            style="
              font-size: 54px;
              letter-spacing: 8px;
              height: 90px;
              width: 200px;
              margin-left: 50px;
            "
            @click="showPrintReport"
            >{{ $t("langcfg.txtPrintOK") }}</el-button
          >
        </div>
      </el-footer>
    </el-container>
    <PrintReport
      v-if="isShowPrintReport"
      :printBaseInfo="printBaseInfo"
      :recordOneInfo="recordOneInfo"
      :recordTwoInfo="recordTwoInfo"
      :whichRecordSelected="whichRecordSelected"
      :selectedVersion="currentVersion"
      :patient="currentPatient"
      :recordList="recordList"
      :record="currentRecord"
      :currentEye="currentEye"
      @close="onClose"
    />
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
// import { saveSettings } from '../../settings'
import { getSystemTime, jsGetAge, objectCopy } from "../../shared/utils";
import { DRYEYEMENUS } from "../../shared/consts";
import PrintReport from "./PrintReport";
import * as recordjs from "../../services/record";
import EVENTS from "../../bus";
import { formatDate } from "../../shared/filters";
import { mapGetters } from "vuex";
import { savePrintSettings } from "../../settings";
let img1px = new Image();
let timeoutLoading;
img1px.onload = () => {};
let reloadMem = {};
export default {
  name: "RecordList",
  mixins: [Size, SubPageSize],
  data() {
    return {
      records: [],
      recordList: [],
      selIndex: [],
      printBaseInfo: {},
      recordOneInfo: {},
      recordTwoInfo: {},
      isShowPrintReport: false,
      selDataODRecords: [],
      selDataOSRecords: [],
      whichRecordSelected: [],
      currentVersion: 1, // 默认经典版
      isZHCN: false,
      isDE: false,
      isIT: false,
      isSelData: false,
      recordsContent: [],
      menus: [],
      printSettings: window.printSettings
    };
  },
  props: {
    currentRecord: Object,
    currentPatient: Object,
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  updated() {
    // 拿到更新的window.settings.language
    this.isZHCN = window.settings.language === "zh_CN";
    this.currentVersion =
      window.settings.language !== "zh_CN"
        ? this.currentVersion === "2"
          ? "1"
          : this.currentVersion
        : this.currentVersion;
    this.isDE = window.settings.language === "de";
    this.isIT = window.settings.language === "it";
  },
  components: {
    PrintReport
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "success-row";
      } else {
        return "";
      }
    },
    tableClick(val) {
      this.isSelData = !this.isSelData;

      if (this.isSelData) {
        this.selRecords([val]);
      } else {
        this.selRecords([]);
      }
    },
    selRecords(val) {
      if (val.length === 0) {
        for (let idx = 0; idx < this.recordList.length; idx++) {
          document.getElementById(`dataOD${idx}`).checked = false;
          document.getElementById(`dataOD${idx}`).disabled = false;
        }
        for (let idx = 0; idx < this.recordList.length; idx++) {
          document.getElementById(`dataOS${idx}`).checked = false;
          document.getElementById(`dataOS${idx}`).disabled = false;
        }
        this.selDataODRecords = [];
        this.selDataOSRecords = [];
        this.selIndex = [];
        return;
      }
      if (val[0] && val[0].content) {
        if (this.selDataODRecords.length + this.selDataOSRecords.length < 2) {
          if (val[0].content.dataOD) {
            if (
              this.selDataODRecords[0] &&
              this.selDataODRecords[0].data.index !== val[0].content.dataOD.data.index
            ) {
              this.selDataOD(val[0].content.dataOD.data.index, val[0].content.dataOD, "OD", "1");
            } else if (!this.selDataODRecords[0]) {
              this.selDataOD(val[0].content.dataOD.data.index, val[0].content.dataOD, "OD", "1");
            }
          }
          if (val[0].content.dataOS) {
            if (
              this.selDataOSRecords[0] &&
              this.selDataOSRecords[0].data.index !== val[0].content.dataOS.data.index
            ) {
              this.selDataOS(val[0].content.dataOS.data.index, val[0].content.dataOS, "OS", "1");
            } else if (!this.selDataOSRecords[0]) {
              this.selDataOS(val[0].content.dataOS.data.index, val[0].content.dataOS, "OS", "1");
            }
          }
        }
      }
      this.selIndex = [];
      for (let id in this.selDataODRecords) {
        this.selIndex.push(this.selDataODRecords[id].data.index);
      }
      for (let id in this.selDataOSRecords) {
        this.selIndex.push(this.selDataOSRecords[id].data.index);
      }
    },
    headerCellStyle(obj) {
      if (obj && obj.columnIndex === 0) {
        return {
          visibility: "hidden"
        };
      } else {
        return {};
      }
    },
    showPrintReport() {
      this.recordOneInfo = {};
      this.recordTwoInfo = {};
      this.printBaseInfo = {};
      if (this.selDataODRecords.length > 0 || this.selDataOSRecords.length > 0) {
        let age =
          !this.currentPatient.birthday || this.currentPatient.birthday === ""
            ? ""
            : jsGetAge(this.currentPatient.birthday);
        this.printBaseInfo = {
          sex: this.currentPatient.sex,
          imgs: [],
          age: age,
          name: this.currentPatient.firstname,
          lastname: this.currentPatient.lastname,
          id: this.currentPatient.pid,
          printdate: formatDate(getSystemTime(), this.dateFormat, true),
          checkdoctor: window.printSettings.general.checkdoctor,
          checkresult: "",
          CheckdateOne: "",
          CheckdateTwo: ""
        };
        console.log(
          "showPrintReport",
          this.selDataODRecords,
          JSON.stringify(this.selDataOSRecords)
        );
        if (this.selDataODRecords.length === 1 && this.printBaseInfo.CheckdateOne === "") {
          this.printBaseInfo.CheckdateOne = formatDate(
            this.selDataODRecords[0].recordtime
              ? this.selDataODRecords[0].recordtime
              : this.selDataODRecords[0].data.date,
            this.dateFormat,
            true
          );
        } else if (this.selDataODRecords.length === 2) {
          this.printBaseInfo.CheckdateOne = formatDate(
            this.selDataODRecords[0].recordtime
              ? this.selDataODRecords[0].recordtime
              : this.selDataODRecords[0].data.date,
            this.dateFormat,
            true
          );
          this.printBaseInfo.CheckdateTwo = formatDate(
            this.selDataODRecords[1].recordtime
              ? this.selDataODRecords[1].recordtime
              : this.selDataODRecords[1].data.date,
            this.dateFormat,
            true
          );
        } else if (this.selDataODRecords.length === 1 && this.printBaseInfo.CheckdateOne) {
          this.printBaseInfo.CheckdateTwo = formatDate(
            this.selDataODRecords[0].recordtime
              ? this.selDataODRecords[0].recordtime
              : this.selDataODRecords[0].data.date,
            this.dateFormat,
            true
          );
        }
        if (this.selDataOSRecords.length === 1 && this.printBaseInfo.CheckdateOne === "") {
          this.printBaseInfo.CheckdateOne = formatDate(
            this.selDataOSRecords[0].recordtime
              ? this.selDataOSRecords[0].recordtime
              : this.selDataOSRecords[0].data.date,
            this.dateFormat,
            true
          );
        } else if (this.selDataOSRecords.length === 2) {
          this.printBaseInfo.CheckdateOne = formatDate(
            this.selDataOSRecords[0].recordtime
              ? this.selDataOSRecords[0].recordtime
              : this.selDataOSRecords[0].data.date,
            this.dateFormat,
            true
          );
          this.printBaseInfo.CheckdateTwo = formatDate(
            this.selDataOSRecords[1].recordtime
              ? this.selDataOSRecords[1].recordtime
              : this.selDataOSRecords[1].data.date,
            this.dateFormat,
            true
          );
        } else if (this.selDataOSRecords.length === 1 && this.printBaseInfo.CheckdateOne) {
          this.printBaseInfo.CheckdateTwo = formatDate(
            this.selDataOSRecords[0].recordtime
              ? this.selDataOSRecords[0].recordtime
              : this.selDataOSRecords[0].data.date,
            this.dateFormat,
            true
          );
        }
        if (this.selDataODRecords.length === 1 && !this.recordOneInfo.data) {
          this.recordOneInfo = this.selDataODRecords[0];
        } else if (this.selDataODRecords.length === 2) {
          this.recordOneInfo = this.selDataODRecords[0];
          this.recordTwoInfo = this.selDataODRecords[1];
        } else if (this.selDataODRecords.length === 1 && this.recordOneInfo.data) {
          this.recordTwoInfo = this.selDataODRecords[0];
        }
        if (this.selDataOSRecords.length === 1 && !this.recordOneInfo.data) {
          this.recordOneInfo = this.selDataOSRecords[0];
        } else if (this.selDataOSRecords.length === 2) {
          this.recordOneInfo = this.selDataOSRecords[0];
          this.recordTwoInfo = this.selDataOSRecords[1];
        } else if (this.selDataOSRecords.length === 1 && this.recordOneInfo.data) {
          this.recordTwoInfo = this.selDataOSRecords[0];
        }
        let isSelOne = this.selDataODRecords.length > 0;
        let isSelTwo = this.selDataOSRecords.length > 0;
        if (isSelOne && isSelTwo) {
          this.whichRecordSelected = [true, true];
        } else if (!isSelOne || !isSelTwo) {
          let one = this.selDataODRecords.length > 1;
          let two = this.selDataOSRecords.length > 1;
          if (one || two) {
            this.whichRecordSelected = [true, true];
          } else {
            this.whichRecordSelected = [true, false];
          }
        }

        this.isShowPrintReport = true;
        // })
      } else {
      }
    },
    onClose() {
      this.isShowPrintReport = false;
      this.$refs.selRecordsTable.clearSelection();
      this.selIndex = [];
      this.printBaseInfo = {};
      this.recordOneInfo = {};
      this.recordTwoInfo = {};
    },
    deletObjPro(Obj) {
      for (var key in Obj) {
        delete Obj[key];
      }
    },
    getCellColor(state, index) {
      let style = {
        // backgroundColor: '#4a4e5a',
        fontSize: "32px",
        color: state ? "#0F0" : "yellow"
      };
      return style;
    },
    // 警示框
    openCenter() {
      this.$message({
        message: this.$t("langcfg.txtReportLimit"),
        center: true,
        type: "error"
      });
    },
    selDataOD(index, data, type, flag, mode) {
      // 这里需要copy个新的data
      let copyData = JSON.parse(JSON.stringify(data));
      copyData.data.type = type;
      let dataOD = document.getElementById(`dataOD${index}`);
      // if (mode) dataOD.checked = !dataOD.checked
      if (this.selDataODRecords.length + this.selDataOSRecords.length < 2) {
        if (flag === "1") {
          dataOD.checked = true;
        }
        if (mode) dataOD.checked = !dataOD.checked;

        if (dataOD.checked) {
          this.selDataODRecords.push(copyData);
        } else {
          this.cancelSel("OD", copyData);
        }
      } else if (!dataOD.checked) {
        this.cancelSel("OD", copyData);
        if (this.selDataODRecords.length + this.selDataOSRecords.length === 2) {
          this.openCenter();
        }
      } else {
        if (mode) dataOD.checked = !dataOD.checked;
        this.cancelSel("OD", copyData);
      }
      this.selOrDisabled();
      // console.log('勾选后的this.selDataODRecords', this.selDataODRecords)
    },
    selDataOS(index, data, type, flag, mode) {
      // 这里需要copy个新的data
      let copyData = JSON.parse(JSON.stringify(data));
      copyData.data.type = type;
      let dataOS = document.getElementById(`dataOS${index}`);

      if (this.selDataODRecords.length + this.selDataOSRecords.length < 2) {
        if (flag === "1") dataOS.checked = true;
        if (mode) dataOS.checked = !dataOS.checked;

        if (dataOS.checked) {
          this.selDataOSRecords.push(copyData);
        } else {
          this.cancelSel("OS", copyData);
        }
      } else if (!dataOS.checked) {
        this.cancelSel("OS", copyData);
        if (this.selDataODRecords.length + this.selDataOSRecords.length === 2) {
          this.openCenter();
        }
      } else {
        if (mode) dataOS.checked = !dataOS.checked;
        this.cancelSel("OS", copyData);
      }
      this.selOrDisabled();
      // console.log('勾选后的this.selDataOSRecords', this.selDataOSRecords)
    },
    cancelSel(type, data) {
      if (type === "OD") {
        for (let id in this.selDataODRecords) {
          if (this.selDataODRecords[id].data.index === data.data.index) {
            this.selDataODRecords.splice(id, 1);
          }
        }
      } else {
        for (let id in this.selDataOSRecords) {
          if (this.selDataOSRecords[id].data.index === data.data.index) {
            this.selDataOSRecords.splice(id, 1);
          }
        }
      }
    },
    // 取消勾选
    selOrDisabled() {
      if (this.selDataODRecords.length + this.selDataOSRecords.length > 1) {
        for (let idx = 0; idx < this.recordList.length; idx++) {
          if (!document.getElementById(`dataOD${idx}`).checked) {
            document.getElementById(`dataOD${idx}`).disabled = true;
          }
          if (!document.getElementById(`dataOS${idx}`).checked) {
            document.getElementById(`dataOS${idx}`).disabled = true;
          }
        }
      } else {
        for (let idx = 0; idx < this.recordList.length; idx++) {
          document.getElementById(`dataOD${idx}`).disabled = false;
          document.getElementById(`dataOS${idx}`).disabled = false;
        }
      }
    },
    getRecordList() {
      this.recordList = [];
      for (let id = 0; id < this.records.length; id++) {
        let _data = {};
        let _record = this.records[id];
        _data["date"] = _record.recorddate;
        _data["index"] = id;
        if (_record.content && _record.content.dataOD && _record.content.dataOS) {
          _record.content.dataOD["data"] = _data;
          _record.content.dataOS["data"] = _data;
          this.recordList.push(_record);
        }
      }

      this.autoChecking(this.recordList);
    },
    // 自动勾选
    autoChecking(data) {
      let that = this;
      let content = {};
      content = data.filter((item) => item._id === that.$store.state.home.pID)[0].content;

      if (content.dataOD.diagnosed) {
        let index = content.dataOD.data.index;
        this.$nextTick(() => {
          this.selDataOD(index, content.dataOD, "OD", "1");
          // this.selOrDisabled()
        });
      } else {
      }
      if (content.dataOS.diagnosed) {
        let index = content.dataOS.data.index;
        this.$nextTick(() => {
          this.selDataOS(index, content.dataOS, "OS", "1");
          // this.selOrDisabled()
        });
      } else {
      }
      clearTimeout(timeoutLoading);
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    },
    selVersion(val) {
      this.currentVersion = val;
      localStorage.setItem("Uinfo", val);
    },
    printSettingsChange(key) {
      let checkedState = document.getElementById(key);
      this.printSettings.dryeye[key] = checkedState.checked;
      this.save();
    },
    save() {
      window.printSettings = this.printSettings;
      savePrintSettings(window.printSettings);
    },
    initMenu() {
      let curTemplate = window.detectSettings.dryeye.templates.find(
        (v) => v.value === window.detectSettings.dryeye.template
      );
      let detectMap = Object.fromEntries(curTemplate.items.map(({ key, show }) => [key, show]));
      let keyOrder = curTemplate.items.map(({ key }) => key);
      const sortKey = (a, b) => {
        let indexA = keyOrder.indexOf(a.key);
        let indexB = keyOrder.indexOf(b.key);
        const orderA = indexA === -1 ? Infinity : indexA;
        const orderB = indexB === -1 ? Infinity : indexB;

        return orderA - orderB;
      };
      this.menus = DRYEYEMENUS.filter((item) => {
        return item.visibleInCapture && detectMap[item.key];
      }).sort(sortKey);
    },
    updateMenu() {
      let beforeCheckMap = Object.fromEntries(
        Array(...document.querySelectorAll(".el-table__row .item>input")).map((v) => [
          v.id,
          v.checked
        ])
      );

      this.initMenu();
      this.$nextTick(() => {
        let afterCheckedMap = Object.fromEntries(
          Array(...document.querySelectorAll(".el-table__row .item>input")).map((v) => [
            v.id,
            v.checked
          ])
        );
        let originMap = Object.fromEntries(
          Object.entries(this.printSettings.dryeye).map(([k]) => [
            k,
            (typeof beforeCheckMap[k] === "undefined" &&
              typeof afterCheckedMap[k] !== "undefined") ||
              !!afterCheckedMap[k]
          ])
        );

        this.printSettings.dryeye = originMap;
        this.save();
      });
    }
  },
  created() {
    this.printSettings = objectCopy(window.printSettings);
    this.initMenu();
    this.$bus.$on("update-menu", this.updateMenu);
    this.$store.state.home.pID = this.currentRecord._id;
  },
  mounted() {
    timeoutLoading = setTimeout(() => {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
    }, 300);
    recordjs.getAllRecordsOfPatientWithContent(
      this.currentPatient._id,
      {
        checktype: "dryeye"
      },
      (data) => {
        if (data.message !== "OK") {
          this.notify(this.$t("langcfg.txtFailToGetRecord"), "", "error");
        } else {
          this.records = data.records.concat();
          this.getRecordList();
        }
      }
    );
    if (!window.settings) {
      window.settings = {};
    }
    localStorage.getItem("Uinfo")
      ? (this.currentVersion = localStorage.getItem("Uinfo"))
      : (this.currentVersion = "1"); // 这里需要string类型
    console.warn(this.menus);
  },
  destroyed() {
    this.$bus.$off("update-menu", this.updateMenu);
  },
  watch: {
    recordsContent: {
      handler(newRecordsContent) {
        this.recordsContent = newRecordsContent;
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters(["dateFormat"]),
    recordListStyle: function () {
      return {
        width: `${this.dispW - 10}px`,
        height: `${this.dispH - 255}px`
      };
    },
    footerStyle: function () {
      return {
        display: `flex`,
        width: `100%`,
        height: "90px"
      };
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 35px;
}
/deep/ .el-button.is-round {
  padding: 12px 0;
}
/deep/.el-table__row--striped td {
  background-color: #6789a0 !important;
}
.el-radio__inner {
  margin-bottom: 10px;
}
/deep/ .el-table__body-wrapper {
  height: auto !important;
  overflow: auto !important;
}
/deep/.el-table .warning-row {
  background: green;
}

/deep/ .el-table .success-row {
  background: #3ae6e647;
}
/deep/ .el-table td,
.el-table th {
  padding: 0;
}
/deep/ .has-gutter tr {
  font-size: 30px;
}
/deep/ .el-button--primary {
  background-color: @blue-selected-color;
  border-color: @blue-selected-color;
}
/deep/ .el-radio__input {
  vertical-align: 1px;
}
.circle {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-left: 30px;
  margin-top: 13px;
  margin-right: 10px;
}
.fullcircle {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: white;
  margin-left: 30px;
  margin-top: 13px;
  margin-right: 10px;
}
/deep/ .row-margin-top {
  height: 825px !important;
}
/deep/ .el-radio__label {
  font-size: 48px;
}
/deep/.is-leaf .cell {
  white-space: nowrap;
  text-align: left;
}
.item {
  padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/RecordList.vue